/** @format */
import Master from '../../Layouts/Master';
import ErrorMessage from '../../../Shared/Components/ErrorMessage';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import useApi from '../../../Shared/hooks/api/Index';
import { error, success } from '../../../Shared/Components/Toast';

const validationSchema = Yup.object().shape({
	title: Yup.string()
		.required('عنوان الزامی است')
		.max(190, 'عنوان نمیتواند بیشتر از 190 کاراکتر باشد'),
});

const CreatePost = () => {
	const navigate = useNavigate();
	const [submitFormLoading, setSubmitFormLoading] = useState(false);

	const onSubmitForm = async (values, setSubmitting) => {
		setSubmitFormLoading(true);

		await useApi.post(
			'/panel/base/post',
			values,
			(res) => {
				success('ساختار تیم با موفقیت ایجاد شد');
				navigate('/panel/base-define/post', { replace: true });
			},
			(err) => {
				setSubmitFormLoading(false);
				error('خطایی در ثبت اطلاعات پیش آمده است.');
			},
		);
	};

	return (
		<Master>
			<Formik
				initialValues={{
					title: '',
				}}
				onSubmit={(values, { setSubmitting }) => {
					onSubmitForm(values, setSubmitting);
				}}
				validationSchema={validationSchema}>
				{({
					values,
					errors,
					handleChange,
					handleSubmit,
					isSubmitting,
					setFieldValue,
				}) => (
					<form onSubmit={handleSubmit}>
						<div className='row border rounded mt-3'>
							<div className='col-12'>
								<div className='form-group'>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>عنوان ساختار تیم</label>
										<input
											name='title'
											value={values.title}
											onChange={handleChange}
											type='text'
											className='form-control'
										/>
										<ErrorMessage error={errors.title} />
									</div>
								</div>
							</div>

							<div className='col-12'>
								<div className='d-flex flex-row justify-content-end'>
									<button className='btn btn-info btn-sm f-14'>
										{submitFormLoading ? (
											<div
												className='spinner-border spinner-border-sm text-white mb-1'
												role='status'></div>
										) : (
											'ثبت ساختار تیم'
										)}
									</button>
								</div>
							</div>
						</div>
					</form>
				)}
			</Formik>
		</Master>
	);
};

export default CreatePost;
